import type { IErrorInfo } from '../errors';
import { errorInfoSchema } from '../errors';
import type { IVocalise } from './vocalise';
import { vocaliseSchemaMap } from './vocalise';
import { actionCreator, Joi, objectSchemaOf } from '../helpers';

export const ERROR = 'VOCALISE/ERROR';

export interface IErrorPayload extends IVocalise {
  error: IErrorInfo;
}

export const errorPayloadSchema = objectSchemaOf<IErrorPayload>({
  ...vocaliseSchemaMap,
  error: errorInfoSchema.required(),
});

export interface IErrorAction {
  type: typeof ERROR;
  payload: IErrorPayload;
}

export const errorActionSchema = objectSchemaOf<IErrorAction>({
  type: Joi.string().required().valid(ERROR),
  payload: errorPayloadSchema.required(),
});

export const error = actionCreator({
  type: ERROR,
  schema: errorActionSchema,
});
